import { useQuery } from "@tanstack/react-query";
import { millisecondsInMinute } from "date-fns";

import { api } from "@contexts";
import { Template, TemplateType } from "@interfaces";

interface UseTemplatesParams {
  templateType?: TemplateType;
}

export const useTemplates = (params?: UseTemplatesParams) => {
  return useQuery({
    queryKey: ["templates", params?.templateType],
    queryFn: () => {
      const urlParams = new URLSearchParams();
      if (params?.templateType) {
        urlParams.set("templateType", params.templateType);
      }
      const queryString = urlParams.toString();
      return api<Template[]>({
        url: `/templates${queryString ? `?${queryString}` : ""}`,
      });
    },
    staleTime: 5 * millisecondsInMinute,
  });
};
